import React, { useState, useEffect, useRef } from "react";
import moment from "moment";

import { routes } from "../../MainPage";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { CommonApiFun } from "../../Redux/Action/index";
import ToastMgs from "../Other/ToastMgs";
export function sundaysInMonth(dayoff) {
  let start = moment(new Date());
  let end = moment().add(2, "months");
  var arr = [];
  dayoff.map((dayIndex) => {
    let tmp = start.clone().day(dayIndex);
    if (tmp.isAfter(start, "d")) {
      arr.push(new Date(tmp.format("MM/DD/YYYY")));
    }
    while (tmp.isBefore(end)) {
      tmp.add(7, "days");
      arr.push(new Date(tmp.format("MM/DD/YYYY")));
    }
  });
  return arr;
}

export function getTimeStops(timediff, timeRnage) {
  var timeStops = [];
  timeRnage.map((item, index) => {
    var startTime = moment(item.start, "HH:mm");
    var endTime = moment(item.end, "HH:mm");

    if (endTime.isBefore(startTime)) {
      endTime.add(1, "day");
    }
    while (startTime < endTime) {
      timeStops.push(new moment(startTime).format("HH:mm"));
      startTime.add(timediff, "minutes");
    }
  });
  return timeStops;
}
function Shedule(props) {
  const Branch = useSelector((state) => state.clinicInfo);
  const dispatch = useDispatch();
  const [fulldDayOff, setFullDayOff] = useState([]);
  const [isloading, setIsloading] = useState(false);
  const { day, time, res, activeTab, Endtime, paymentRes, branchOption } =
    props.data;
  const [newTimeDis, setNewTimeDis] = useState([]);
  const [bookedSlot, setBookedSlot] = useState("");
  const [isDateloading, setIsDateloading] = useState(false);
  var { available, holiday, reserved_slot, new_patient_appoinment_fee } = res
    ? res.data
    : {};
  var newFormate = moment(day).format("YYYY-MM-DD");
  var reserved_date = reserved_slot ? Object.keys(reserved_slot) : [];
  var slotDate =
    newFormate && reserved_date.includes(newFormate)
      ? reserved_date.indexOf(newFormate)
      : -1;
  var holidayDateArr = holiday ? holiday.map((item) => item.date) : [];
  var holidayDate =
    newFormate && holidayDateArr.includes(newFormate)
      ? holidayDateArr.indexOf(newFormate)
      : -1;
  if (holidayDate !== -1) {
    var { appoinment_time } = available.days;
    var { morning_end, morning_start, afternoon_end, afternoon_start } =
      holiday[holidayDate].time;
    var timeArr = [];
    if (morning_start !== "00:00" && morning_end !== "00:00") {
      timeArr.push({ start: morning_start, end: morning_end });
    }
    if (afternoon_end !== "00:00" && afternoon_start !== "00:00") {
      timeArr.push({ start: afternoon_start, end: afternoon_end });
    }
    var allTimes1 = getTimeStops(appoinment_time, timeArr);
  }

  var timeDis = newTimeDis.map((time) => time[0]);
  if (newFormate == moment().format("YYYY-MM-DD")) {
    var beginningTime = "09:00";
    var endTime = moment().format("HH:mm");
  }

  const maxDate = moment().add(2, "months").format("MM-DD-YYYY");
  const isDisabled = isloading ? true : day == "" || time == "" ? true : false;
  var daysInWeek = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
  ];
  var avilableDays = available && available.time;
  var difference = avilableDays
    ? daysInWeek.filter((x) => !avilableDays.includes(x))
    : [];
  var dayoff = [];
  difference.map((item, index) => {
    dayoff.push(daysInWeek.indexOf(item));
  });
  var excludeDates = sundaysInMonth(dayoff);
  var {
    appoinment_time,
    morning_start,
    morning_end,
    afternoon_start,
    afternoon_end,
  } = available ? available.days : {};
  var allTimes =
    available &&
    getTimeStops(appoinment_time, [
      { start: morning_start, end: morning_end },
      { start: afternoon_start, end: afternoon_end },
    ]);
  const slotArr = allTimes1 ? allTimes1 : allTimes;

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
    if (res != "") {
      holiday.map((item) => {
        var { afternoon_end, afternoon_start, morning_end, morning_start } =
          item.time;
        if (
          afternoon_end == "00:00" &&
          afternoon_start == "00:00" &&
          morning_end == "00:00" &&
          morning_start == "00:00"
        ) {
          setFullDayOff([...fulldDayOff, new Date(item.date)]);
        }
      });
    }
    return () => {
      document.body.removeChild(script);
    };
  }, [res]);
  // useEffect(() => {
  //   alert("dsdh")
  // },[branchOption.value])
  const handleDayClick = (day, branch_type) => {
    props.handleState("day", day);
    props.handleState("time", "");
    //        api/fetch_slots/post
    setIsDateloading(true);
    var data = {
      date: moment(day).format("YYYY-MM-DD"),
      patient_id: props.isoldPatient ? res.patient.patient_key : "",
      branch_type: branch_type.id,
    };
    dispatch(CommonApiFun("api/fetch_slots/post", JSON.stringify(data)))
      .then((res) => {
        setBookedSlot(res.booked_slot);

        // setappointmentId(res.appointment_id)
        if (res.booked_slot != "") {
          props.handleState("time", res.booked_slot.start_time);
          //  props.handleState("time", item)
          props.handleState(
            "Endtime",
            moment(res.booked_slot.start_time, "HH:mm")
              .add(appoinment_time, "minutes")
              .format("HH:mm")
          );
        }
        setNewTimeDis(res.reserved_slots);
        setIsDateloading(false);
      })
      .catch((e) => {});
  };

  const onSeleteTime = (item, index) => {
    var startTime = moment(item, "HH:mm");
    if (typeof timeDis == "undefined") {
      props.handleState("time", item);
      props.handleState(
        "Endtime",
        startTime.add(appoinment_time, "minutes").format("HH:mm")
      );
    } else if (timeDis && !timeDis.includes(item)) {
      props.handleState("time", item);
      props.handleState(
        "Endtime",
        startTime.add(appoinment_time, "minutes").format("HH:mm")
      );
    }
  };

  const onsubmit = (e) => {
    e.preventDefault();
    if (day == "" || time == "") {
      //   alert("Dfdksjfh")
      toast(
        <ToastMgs
          status={"fail"}
          message={"Please select a date and time at your convenience"}
        />
      );
    } else {
      setIsloading(true);

      var data = {
        date: moment(day).format("YYYY-MM-DD"),
        appointment_start_time: time,
        appointment_end_time:
          Endtime != ""
            ? Endtime
            : time.add(appoinment_time, "minutes").format("HH:mm"),
        patient_id: res.patient_key,
        charge: new_patient_appoinment_fee,
        appointment_id: paymentRes == "" ? "" : paymentRes.appointmentKey,
        appointment_by: 0,
        branch_type: branchOption.value.id,
      };
      //http://192.169.143.211/~devapp/ansh_clinic/admin/api/appointment_history/post
      dispatch(
        CommonApiFun("api/appointment_history/post", JSON.stringify(data))
      )
        .then((res) => {
          props.handleState("paymentRes", res);

          props.handleNext(3);
          if (res.status == "success") {
            props.handleState("paymentRes", res);
            toast(
              <ToastMgs
                status={res.status}
                message={
                  paymentRes == ""
                    ? "Your appointment has been scheduled"
                    : "Your appointment has been rescheduled"
                }
              />
            );
            // toast( <Msg status={res.status}  message={paymentRes == "" ? "your appointment has been scheduled" : "your appointment has been rescheduled"}></Msg>)
            props.handleNext(3);
          } else {
            toast(<ToastMgs status={res.status} message={res.message} />);
          }
          setIsloading(false);
        })
        .catch((e) => {
          toast.error("Oops! ,something went wrong try again later...");
          setIsloading(false);
        });
    }
  };

  const submitData = (e) => {
    e.preventDefault();

    if (day == "" || time == "") {
      toast(
        <ToastMgs
          status={"failed"}
          message={"Please select a date and time at your convenience"}
        />
      );
    } else {
      setIsloading(true);
      setIsDateloading(true);

      var data = {
        appointment_start_time: time,
        appointment_end_time: Endtime,
        file_id: res.fileId,
        charge: res.data.old_patient_appoinment_fee,
        patient_id: res.patient.patient_key,
        appointment_date: moment(day).format("YYYY-MM-DD"),
        appointment_id: bookedSlot.appointment_id,
        branch_type: branchOption.value.id,
      };

      dispatch(CommonApiFun("api/New_appointment/post", JSON.stringify(data)))
        .then(async (res) => {
          if (res.status == "success") {
            PaypalPaymnet(res);
          } else {
            setIsloading(false);
            setIsDateloading(false);
            toast(<ToastMgs status={res.status} message={res.message} />);
          }
        })
        .catch((e) => {
          toast.error("Oops! ,something went wrong try again later...");
        });
    }
  };
  const PaypalPaymnet = (result) => {
    const { key, amount, order_id, currency } = result.data;

    const options = {
      key: key,
      currency: "INR",
      amount: amount, //  = INR 1
      name: "Ansh clinic",
      description: "some description",
      order_id: order_id,
      modal: {
        ondismiss: function () {
          setIsloading(false);
          setIsDateloading(false);
        },
      },
      handler: function (response) {
        response.pid = res.patient.patient_key;
        response.tid = result.transaction_id;
        response.aid = result.appointment_id;
        dispatch(
          CommonApiFun("api/payment_approve/post", JSON.stringify(response))
        )
          .then(async (res) => {
            setIsloading(false);
            setIsDateloading(false);
            props.handleState("day", "");
            props.handleState("time", "");
            props.handleNext();
          })
          .catch((e) => {
            toast.error("Oops! ,something went wrong try again later...");
          });
      },
      prefill: {
        name: res.patient.first_name + " " + res.patient.last_name,
        contact: "91" + res.patient.mobile_no,
        email: res.patient.email,
      },
      notes: {
        address: res.patient.address,
      },
    };

    var rzp1 = new window.Razorpay(options);
    rzp1.open();
  };
  return (
    <div className={`main ${activeTab == 2 ? "active" : ""}`}>
      {isDateloading && (
        <div className="payment-loader">
          <span></span>
        </div>
      )}
      <div className="row schedule_header">
        <div className="text">
          <h3>Schedule</h3>
          <p>Inform companies about your education life.</p>
        </div>
        <div className="slots_info">
          <div className="slots_slab">
            <div className="slots_time available_slot">
              <span>Available time Slots</span>
            </div>
            <div className="slots_time selected_slot">
              <span>selected time Slots</span>
            </div>
            <div className="slots_time booked_slot">
              <span>Booked time Slots</span>
            </div>
            {day && (
              <div className="slots_time alreday_booked_slot">
                <span>Booked by you</span>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="main-content">
        <div className="input-text blood_branch">
          <div className="input-div">
            <DatePicker
              selected={day !== "" && day}
              excludeDates={[...excludeDates, ...fulldDayOff]}
              minDate={new Date()}
              maxDate={new Date(maxDate)}
              placeholderText="Select date*"
              dateFormat="yyyy-MM-dd"
              onChange={(date) => handleDayClick(date, branchOption.value)}
            />
          </div>
          <div className="input-div">
            <ul>
              <li className="dropdown blod_group">
                <a
                  href="javascript:void(0)"
                  onClick={() => {
                    props.handleState("branchOption", {
                      show: !branchOption.show,
                      value: branchOption.value,
                    });
                  }}
                  data-toggle="dropdown"
                >
                  {branchOption.value.title.charAt(0).toUpperCase() +
                    branchOption.value.title.slice(1)}
                  <i
                    className={`icon-arrow fas fa-plus ${
                      branchOption.show ? "open" : "close"
                    }`}
                  ></i>
                </a>
                <ul
                  className={`dropdown-menu ${
                    branchOption.show ? "show" : "hide"
                  }`}
                >
                  {Branch.map((item) => {
                    return (
                      <li key={item.id}>
                        <a
                          href="javascript:void(0)"
                          onClick={async () => {
                            await props.handleState("branchOption", {
                              show: !branchOption.show,
                              value: item,
                            });
                            day !== "" && handleDayClick(day, item);
                          }}
                        >
                          {item.title.charAt(0).toUpperCase() +
                            item.title.slice(1)}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div className="slots">
          <ul>
            {day !== "" &&
              slotArr &&
              slotArr.map((item, index) => {
                return (
                  <>
                    <li
                      className={`${timeDis.includes(item) ? "disable" : ""} ${
                        bookedSlot.payment_status == "0" ? "disable" : ""
                      } 
                                     ${
                                       bookedSlot.payment_status == "0"
                                         ? "disable"
                                         : ""
                                     } 
                                     ${
                                       newFormate ==
                                         moment().format("YYYY-MM-DD") &&
                                       moment().format("HH:mm") > item
                                         ? "disable"
                                         : ""
                                     } ${item == time ? "selected" : ""}   ${
                        bookedSlot.start_time == item ? "booked" : ""
                      }`}
                      onClick={() => {
                        onSeleteTime(item, index);
                      }}
                    >
                      {item} <span>{moment(item, "hh:mm").format("LT")}</span>
                    </li>
                  </>
                );
              })}
          </ul>
        </div>
      </div>
      <div className="buttons button_space">
        {" "}
        <button
          className="btn back_button btn-relative"
          onClick={() => props.handlePrev()}
        >
          Back
        </button>{" "}
        <button
          className={`btn next_button btn-relative ${
            bookedSlot.payment_status == "1" || day == "" || time == ""
              ? "disable"
              : ""
          } ${isloading ? "btn--loading" : ""}`}
          onClick={(e) => (props.isoldPatient ? submitData(e) : onsubmit(e))}
        >
          <span className="btn-text">
            {props.isoldPatient ? "Payment" : "Next"}
          </span>
          <span className="btn__loader">
            <div
              role="progressbar"
              aria-valuemin={0}
              aria-valuemax={100}
              className="progress-circular progress-circular--visible progress-circular--indet"
              style={{ height: 23, width: 23 }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="21.904761904761905 21.904761904761905 43.80952380952381 43.80952380952381"
                style={{ transform: "rotate(0deg)" }}
              >
                <circle
                  fill="transparent"
                  cx="43.80952380952381"
                  cy="43.80952380952381"
                  r={20}
                  strokeWidth="3.8095238095238093"
                  strokeDasharray="125.664"
                  strokeDashoffset="125.66370614359172px"
                  className="progress-circular__overlay"
                />
              </svg>
            </div>
          </span>
        </button>
      </div>
    </div>
  );
}

export default Shedule;
